import { getToken } from '@/utils/KeycloakUtils'
import type { PostCoverageconceptRequest, ProductSubType } from 'shur-api'

export async function fetchShurContractByPolicyId(policyId: string) {
  const token = await getToken()

  return fetch(`${globalThis.ENV_CONFIG?.SERVICE_HOSTS.SHUR}/contracts/${policyId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      KeyId: globalThis.ENV_CONFIG?.API_KEY,
      'Content-Type': 'application/json'
    },
    method: 'GET'
  }).then(async (response) => {
    if (!response.ok) {
      throw new Error(response.statusText)
    }
    return await response.json()
  })
}

export async function fetchShurContractDetailsByPolicyId(
  policyId: string,
  productSubType: ProductSubType | undefined
) {
  const token = await getToken()

  const params = new URLSearchParams()

  if (productSubType !== undefined) {
    params.append('productSubType', productSubType)
  }

  //const vsnr = getPolicyNumber(policyId)

  const queryString = params.toString()
  const url = queryString
    ? `${globalThis.ENV_CONFIG?.SERVICE_HOSTS.SHUR}/contracts/details/${policyId}?${queryString}`
    : `${globalThis.ENV_CONFIG?.SERVICE_HOSTS.SHUR}/contracts/details/${policyId}`

  return fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      KeyId: globalThis.ENV_CONFIG?.API_KEY,
      'Content-Type': 'application/json'
    },
    method: 'GET'
  }).then(async (response) => {
    if (!response.ok) {
      throw new Error(response.statusText)
    }
    return await response.json()
  })
}

export async function fetchCoverageConceptPDFByContractId(
  contractId: string,
  coverageConceptType: string,
  shurSubLine: ProductSubType,
  productVersion?: string
) {
  const token = await getToken()

  const postCoverageconceptRequest: PostCoverageconceptRequest = {
    contractId: contractId,
    coverageConceptType: coverageConceptType,
    shurSubLine: shurSubLine,
    productVersion: productVersion
  }

  return fetch(`${globalThis.ENV_CONFIG?.SERVICE_HOSTS.SHUR}/coverageconcept`, {
    headers: {
      Authorization: `Bearer ${token}`,
      KeyId: globalThis.ENV_CONFIG?.API_KEY,
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: JSON.stringify(postCoverageconceptRequest)
  }).then(async (response) => {
    if (!response.ok) {
      throw new Error(response.statusText)
    }
    return await response.blob()
  })
}
